import { css } from '@happymoneyinc/styled-components';

const focus = css`
  &:focus {
    outline-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.flamingo[1];
}};
    outline-style: dashed;
    outline-width: 1px;
  }
`;

export { focus as default, focus };
//# sourceMappingURL=global-styles.js.map
